export enum NeutPosition {
    Left,
    Center,
    Right
}